import PropTypes from 'prop-types';
import React from 'react';
import Lightbox from 'react-image-lightbox';
import StaffPicks from 'components/Badges/StaffPicks/StaffPicks';
import SvgIcon from 'components/SvgIcon/SvgIcon';
import { getThumbnailByWidth } from 'helpers/HelperFunctions';
import styles from './ImagePlayer.module.scss';
import 'react-image-lightbox/style.css';

function getDisplayImage(thumbnails) {
  if (!thumbnails) {
    return '';
  }

  if (thumbnails.original_optimised) {
    return thumbnails.original_optimised;
  }

  if (thumbnails.original) {
    return thumbnails.original;
  }

  if (thumbnails.images && Object.keys(thumbnails.images).length > 0) {
    try {
      return getThumbnailByWidth(thumbnails.images, 500) || '';
    } catch (e) {
      return '';
    }
  }

  return '';
}

class ImagePlayer extends React.Component {
  static propTypes = {
    onLoad: PropTypes.func,
    onZoom: PropTypes.func,
    project: PropTypes.object.isRequired,
    staffPicks: PropTypes.bool,
    user: PropTypes.object,
    zoom: PropTypes.bool,
  };

  static defaultProps = {
    zoom: true,
  };

  constructor() {
    super();

    this.state = {
      imgLoaded: false,
      zoomed: false,
    };

    this.handleLoadImage = this.handleLoadImage.bind(this);
  }

  componentDidMount() {
    if (this.refs.hiddenImage && this.refs.hiddenImage.complete) {
      this.handleLoadImage();
    }
  }

  handleLoadImage() {
    this.setState({
      imgLoaded: true,
    });

    if (this.props.onLoad) {
      this.props.onLoad();
    }
  }

  handleZoom() {
    if (this.props.onZoom) {
      this.props.onZoom();
    }
  }

  render() {
    const { project, staffPicks, zoom, user } = this.props;
    const { imgLoaded, zoomed } = this.state;
    const { thumbnails } = project;
    const isProcessing = project.state === 'processing';
    const displayImage = getDisplayImage(thumbnails);
    const hasRealOriginal = Boolean(
      (thumbnails && thumbnails.original_optimised) ||
        (thumbnails && thumbnails.original)
    );
    const canZoom = zoom && hasRealOriginal && !isProcessing;

    return (
      <div>
        <span
          itemProp="embedUrl"
          content={
            project && project.links && project.links.widget
              ? project.links.widget
              : ''
          }
        />
        <span itemProp="thumbnail" content={displayImage} />
        <span
          itemProp="datePublished"
          content={project && project.created_at ? project.created_at : ''}
        />
        <span
          itemProp="author"
          content={user && user.displayname ? user.displayname : ''}
        />
        <div
          className={`${styles.imageContainer} ${canZoom ? styles.zoom : ''}`}
          onClick={() => (canZoom ? this.setState({ zoomed: !zoomed }) : null)}
          style={{
            backgroundColor: thumbnails.color ? thumbnails.color : '#eee',
            position: 'relative',
          }}
        >
          {displayImage ? (
            <>
              <div
                className={`${styles.backgroundDiv} ${
                  imgLoaded ? styles.backgroundLoaded : ''
                }`}
                style={{ backgroundImage: `url('${displayImage}')` }}
              />
              <img
                alt="Twine"
                className={styles.hiddenImage}
                ref="hiddenImage"
                onLoad={() => this.handleLoadImage()}
                src={displayImage}
              />
            </>
          ) : null}
          {isProcessing && (
            <div className={styles.processingOverlay} role="status">
              <span className={styles.processingLabel}>
                Media is still processing
              </span>
            </div>
          )}
        </div>
        {staffPicks ? (
          <StaffPicks
            project={project}
            style={{
              position: 'absolute',
              width: '20%',
              bottom: '15px',
              left: '15px',
            }}
          />
        ) : null}
        {canZoom && (
          <SvgIcon
            icon="zoom"
            color="white"
            size="20"
            className={styles.zoomIcon}
          />
        )}
        {canZoom && zoomed ? (
          <Lightbox
            mainSrc={displayImage}
            discourageDownloads
            onCloseRequest={() => this.setState({ zoomed: false })}
          />
        ) : null}
      </div>
    );
  }
}

export default ImagePlayer;
